import { reduce, omit } from 'lodash-es';
import { getValidParams, parseVehicleParam } from 'client/utils/parse-vehicle-param';
import { VEHICLE_PATH_NAME, MAX_COMPARE_SIZE, vehicleRegExp } from 'site-modules/comparator/constants/comparator';

function orderVehicles(query) {
  let index = 1;
  return reduce(
    query,
    (result, value) => {
      result[`${VEHICLE_PATH_NAME}${index}`] = value; // eslint-disable-line no-param-reassign
      index += 1;
      return result;
    },
    {}
  );
}

export function normalizeQueryOrder(query, pathname = '') {
  const { additionalParams, vehParams } = reduce(
    query,
    (result, value, key) => {
      result[key.match(vehicleRegExp) ? 'vehParams' : 'additionalParams'][key] = value; // eslint-disable-line no-param-reassign
      return result;
    },
    { additionalParams: {}, vehParams: {} }
  );
  return {
    pathname,
    query: {
      ...orderVehicles(vehParams),
      ...additionalParams,
    },
  };
}

export function normalizeQuery(query, pathname = '', columnsNumber = MAX_COMPARE_SIZE, hasSponsoredColumn = false) {
  const newState = normalizeQueryOrder(query, pathname);
  let newQuery = newState.query;

  for (let i = 1; i <= MAX_COMPARE_SIZE; i += 1) {
    const name = `${VEHICLE_PATH_NAME}${i}`;
    if (i > columnsNumber || !newQuery[name] || !getValidParams(newQuery[name]).length) {
      newQuery = omit(newQuery, name);
    }
  }

  if (hasSponsoredColumn) {
    const lastColumnName = `${VEHICLE_PATH_NAME}${columnsNumber}`;
    if (newQuery[lastColumnName]) {
      newQuery = omit(newQuery, lastColumnName);
    }
  }

  newState.query = newQuery;

  return newState;
}

export function firstVehicle(query, columnsNumber) {
  for (let i = 1; i <= columnsNumber; i += 1) {
    const name = `${VEHICLE_PATH_NAME}${i}`;
    if (name in query) {
      return parseVehicleParam(query, name);
    }
  }
  return undefined;
}
